export default __webpack_public_path__ + "static/media/NGLP.6ce77a65.png";